import { Fragment, useEffect, useRef, useState } from "react";
import moment from "moment";
import { Button, Col, Row } from "reactstrap";
import Box from "../../../../components/widget/Box";
import { selectTrainingLaunch } from "../../../../redux/slices/trainingSlice";
import { useAppSelector } from "../../../../redux/hooks";
import { useMedia } from "react-media";
import { format, isToday } from "date-fns";
import NotificationAlert from "react-notification-alert";
import { fr } from "date-fns/locale";
import { ReactComponent as LockIcon } from "../../../../assets/img/icons/lock.svg";
import { ReactComponent as ReDoIcon } from "../../../../assets/img/icons/redo.svg";
import { ReactComponent as DoneIcon } from "../../../../assets/img/icons/doneSm.svg";
import { BsFillFileEarmarkPdfFill } from "react-icons/bs";
import { FaFilePowerpoint, FaMicrophone } from "react-icons/fa";
import { AiFillVideoCamera } from "react-icons/ai";
import TraininhContentHeader from "./TrainingContentHeader";
import TrainingNav from "./TrainingNav";
import TrainingContent from "./TrainingContent";
import ReactTooltip from "react-tooltip";
import TrainingService from "../../../../services/training.services";
import useHttp from "../../../../hooks/use-http";
import { Field, Form, Formik } from "formik";
import GamificationModal from "../../../../components/GamificationModal";

const TrainingSynchrone = (props: any) => {
  //Init props
  const { contentType, setContentType } = props;

  //Init states from selector
  const data: any = useAppSelector(selectTrainingLaunch);

  //Init states
  const [codeValidation, setCodeValidation] = useState("");
  const [attempts, setAttempts] = useState(0);
  const [isTruthy, setIsTruthy] = useState("pending");
  const [comment, setComment] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [selectedElement, setSelectedElement] = useState(1000);
  //Init Global Media Queries
  const GLOBAL_MEDIA_QUERIES = {
    small: "(max-width: 991px)",
    large: "(min-width: 992px)",
  };

  const matches = useMedia({ queries: GLOBAL_MEDIA_QUERIES });

  //Init notification ref
  const notificationAlert = useRef();

  const { sendRequest, status } = useHttp(TrainingService.postFeedback);
  const { sendRequest: codeValidationRequest, data: popupData } = useHttp(
    TrainingService.postCodeValidationStatus
  );
  const { sendRequest: checkcodeValidationRequest, data: isCorrect } = useHttp(
    TrainingService.postCheckCodeValidation
  );

  /**
   * Handle code validation changes
   * @param ev
   * @param setFieldValue
   * @param valueName
   */
  const handleChange = (ev: any, setFieldValue: any, valueName: string) => {
    setFieldValue(valueName, ev.target.value);
    setCodeValidation(codeValidation + ev.target.value);
    (codeValidation + ev.target.value).length === 4 &&
      checkcodeValidationRequest({
        formationId: data.id,
        code_validation: codeValidation + ev.target.value,
      });
  };
  const validateCode = () => {
    setIsTruthy("true");
    codeValidationRequest({ formationId: data.id, status_validation: "on" });
    setModalShow(true);
  };
  const blockOrSetAttemptsCode = () => {
    setIsTruthy("false");
    attempts === 4 &&
      codeValidationRequest({
        formationId: data.id,
        status_validation: "blocked",
      });
  };
  //Effects
  useEffect(() => {
    if (status === "completed") {
      //@ts-ignore
      notificationAlert.current.notificationAlert({
        place: "tr",
        message: <div>{"Vos feedbacks ont bien été sauvegardés."}</div>,
        type: "success",
        icon: "nc-icon nc-bell-55",
        closeButton: false,
        autoDismiss: 7,
      });
    }
  }, [status]);

  useEffect(() => {
    if (isCorrect && isCorrect.code_validation) {
      validateCode();
    }
    if (isCorrect && isCorrect.code_validation === false) {
      codeValidation.length === 4 && blockOrSetAttemptsCode();
    }
  }, [isCorrect]);

  useEffect(() => {
    setAttempts(data.attempts);
  }, [data]);
  useEffect(() => {
    isCorrect && isCorrect.attempts && setAttempts(isCorrect.attempts);
  }, [isCorrect]);

  if (data.typology !== "sync") {
    return (
      <>
        {contentType === "content" && (
          <TraininhContentHeader></TraininhContentHeader>
        )}
        {contentType === "content" && <TrainingNav></TrainingNav>}
        {contentType === "content" && (
          <TrainingContent setContentType={setContentType}></TrainingContent>
        )}
      </>
    );
  }

  //Test code
  const today = moment(new Date(), "YYYYMMDD");
  const trainingDate = moment(data.eventDetails.date, "YYYYMMDD");
  const hasPassed: boolean =
    today < trainingDate
      ? false
      : today === trainingDate
      ? today.hour() > Number(data.eventDetails.endTimeHour)
        ? true
        : today.hour() === Number(data.eventDetails.endTimeHour)
        ? today.minutes() > Number(data.eventDetails.endTimeMinute)
          ? true
          : false
        : false
      : true;

  //Init code validation values
  const initialValues = {
    firstValue: "",
    secondValue: "",
    thirdValue: "",
    fourthValue: "",
  };

  const sendFeedback = () => {
    const note = selectedElement !== 1000 && selectedElement + 1;
    const cmt = comment !== "" && comment;
    if (cmt && note) {
      const feedback = {
        note,
        comment: cmt,
      };
      sendRequest({ formationId: data.id, feedback });
    } else if (cmt) {
      const feedback = {
        comment: cmt,
      };
      sendRequest({ formationId: data.id, feedback });
    } else {
      const feedback = {
        note,
      };
      sendRequest({ formationId: data.id, feedback });
    }
  };

  const sectionData = data?.eventDetails;
  const getIcons = (attachType: string) => {
    if (attachType === "pdf") {
      return (
        <BsFillFileEarmarkPdfFill
          size={50}
          color="#3367cd"
          className="ms-2 iconOutlined"
        />
      );
    }
    if (attachType === "mp3") {
      return (
        <FaMicrophone size={50} color="#3367cd" className="ms-2 iconOutlined" />
      );
    }
    if (attachType === "mp4") {
      return (
        <AiFillVideoCamera
          size={50}
          color="#3367cd"
          className="ms-2 iconOutlined"
        />
      );
    }
    if (attachType === "ppt" || attachType === "pptx") {
      return (
        <FaFilePowerpoint
          size={50}
          color="#3367cd"
          className="ms-2 iconOutlined"
        />
      );
    }
    return (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.6001 36H10.4001C8.63276 36 7.20007 34.5673 7.20007 32.8V14.928C7.1994 14.0751 7.53921 13.2573 8.14408 12.656L15.8561 4.944C16.4574 4.33914 17.2752 3.99933 18.1281 4H29.6001C31.3674 4 32.8001 5.43269 32.8001 7.2V32.8C32.8001 34.5673 31.3674 36 29.6001 36ZM18.4001 13.6V6.912L10.1121 15.2H16.8001C17.6837 15.2 18.4001 14.4837 18.4001 13.6Z"
          fill="#3367CD"
        />
        <path
          d="M15.8083 25.55C15.8083 25.82 16.0243 26.036 16.2943 26.036C16.5643 26.036 16.7863 25.82 16.7863 25.55C16.7863 25.28 16.5643 25.058 16.2943 25.058C16.0243 25.058 15.8083 25.28 15.8083 25.55ZM17.2476 26H18.0456C18.0996 25.91 18.6456 25.112 18.7056 25.022L19.3836 26H20.1996L19.1376 24.512L20.1636 23.078H19.3716L18.7356 24.014C18.6816 23.93 18.1476 23.168 18.0936 23.078H17.2656L18.3096 24.524L17.2476 26ZM21.4038 26V21.656H20.7078V26H21.4038ZM22.0436 25.208C22.0796 25.538 22.4036 26.09 23.2496 26.09C23.9936 26.09 24.3536 25.598 24.3536 25.154C24.3536 24.722 24.0656 24.386 23.5136 24.266L23.0696 24.176C22.8896 24.14 22.7756 24.026 22.7756 23.87C22.7756 23.69 22.9496 23.534 23.1956 23.534C23.5856 23.534 23.7116 23.804 23.7356 23.972L24.3236 23.804C24.2756 23.516 24.0116 22.988 23.1956 22.988C22.5896 22.988 22.1216 23.42 22.1216 23.93C22.1216 24.332 22.3916 24.668 22.9076 24.782L23.3396 24.878C23.5736 24.926 23.6816 25.046 23.6816 25.202C23.6816 25.382 23.5316 25.538 23.2436 25.538C22.8716 25.538 22.6736 25.304 22.6496 25.04L22.0436 25.208Z"
          fill="white"
        />
      </svg>
    );
  };
  const colors = ["#FF66A9", "#ED984F", "#3367CD", "#3367CD", "#3367CD"];
  const tooltips = [
    "Pas du tout",
    "Un peu",
    "Bien",
    "Très bien",
    "Parfaitement",
  ];
  const getFeedBackIcons = () => {
    return tooltips.map((val, idx) => {
      return (
        <div
          data-tip={val}
          onClick={() => {
            setSelectedElement(idx);
          }}
        >
          <svg
            width="22"
            height="21"
            viewBox="0 0 22 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.9999 17.5875L16.1874 20.725C17.1374 21.3 18.2999 20.45 18.0499 19.375L16.6749 13.475L21.2624 9.5C22.0999 8.775 21.6499 7.4 20.5499 7.3125L14.5124 6.8L12.1499 1.225C11.7249 0.212501 10.2749 0.212501 9.84991 1.225L7.48741 6.7875L1.44991 7.3C0.349908 7.3875 -0.100092 8.7625 0.737408 9.4875L5.32491 13.4625L3.94991 19.3625C3.69991 20.4375 4.86241 21.2875 5.81241 20.7125L10.9999 17.5875Z"
              fill={
                idx <= selectedElement && selectedElement !== 1000
                  ? colors[selectedElement]
                  : "#ECF0FB"
              }
            />
          </svg>
          <ReactTooltip />
        </div>
      );
    });
  };
  const getMeetingTool = () => {
    const url = sectionData.location.toLowerCase();
    return url.includes("meet.google")
      ? "Google Meet"
      : url.includes("skype")
      ? "Skype"
      : url.includes("teams")
      ? "Teams"
      : url.includes("zoom")
      ? "Zoom"
      : url.includes("slack")
      ? "Slack"
      : url.includes("whereby")
      ? "Whereby"
      : "";
  };

  return (
    <Fragment>
      {/** 
        //@ts-ignore */}
      <NotificationAlert ref={notificationAlert} />
      <GamificationModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        data={popupData && popupData.popUpInformation}
      />
      {matches.large ? (
        <div className="preview-content-header d-flex">
          <Col md="8">
            <Row className="d-flex preview-title">
              <Col md={{ offset: 4 }}>
                <div className="label-white-xlg">{data?.title}</div>
              </Col>
            </Row>
            <Row className="d-flex preview-subject">
              <Col className="d-flex" md={{ offset: 4 }}>
                {data.subject.map((sub: any) => {
                  return (
                    <Box
                      key={sub.id}
                      content={sub.label}
                      background="#ECF0FB"
                      color="#3367CD"
                    ></Box>
                  );
                })}
              </Col>
            </Row>
            <Row className="d-flex preview-subject">
              <Col className="d-flex" md={{ offset: 4 }}>
                <svg
                  width="18"
                  height="15"
                  viewBox="0 0 18 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 9V2C8 0.89543 7.10457 0 6 0H2C0.89543 0 0 0.89543 0 2V6C0 7.10457 0.89543 8 2 8H5V9C5.01856 9.96862 4.34023 10.8113 3.39 11C3.1683 11.0498 3.0081 11.2429 3 11.47V13.47C2.99257 13.6252 3.05492 13.7756 3.17 13.88C3.27637 13.9748 3.41874 14.0186 3.56 14C6.10071 13.7137 8.01608 11.5567 8 9ZM12 0H16C17.1046 0 18 0.89543 18 2V9C18.011 11.5529 16.0969 13.7041 13.56 13.99C13.4187 14.0086 13.2764 13.9648 13.17 13.87C13.0629 13.7725 13.0013 13.6348 13 13.49V11.49C12.9989 11.2554 13.1611 11.0516 13.39 11C14.3402 10.8113 15.0186 9.96862 15 9V8H12C10.8954 8 10 7.10457 10 6V2C10 0.89543 10.8954 0 12 0Z"
                    fill="#ECF0FB"
                  />
                </svg>
                <div className="label-white-lg pl-10">
                  {" "}
                  À propos de la formation
                </div>
              </Col>
            </Row>
            <Row className="d-flex preview-subject">
              <Col md={{ offset: 4 }}>
                {data?.description.replace(/<br\s*\/?>/gm, "\r\n").split(/[\n]+/).map((item: any, idx: any) => (
                  <div key={idx} className="label-white-md">
                    {item}
                    <br />
                  </div>
                ))}
              </Col>
            </Row>
          </Col>
          <Col md="4" className="d-flex">
            <Col>
              <div className="box">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0ZM10 3C11.6569 3 13 4.34315 13 6C13 7.65685 11.6569 9 10 9C8.34315 9 7 7.65685 7 6C7 4.34315 8.34315 3 10 3ZM10 16.9868C12.2151 16.9868 14.2994 15.9384 15.62 14.16C15.8246 13.8609 15.8514 13.4745 15.69 13.15L15.46 12.68C14.9568 11.6531 13.9136 11.0015 12.77 11H7.23C6.07012 11.0012 5.01488 11.671 4.52 12.72L4.31 13.16C4.15251 13.4818 4.17921 13.8633 4.38 14.16C5.70056 15.9384 7.78493 16.9868 10 16.9868Z"
                    fill="#3367CD"
                  />
                </svg>
                <div className="label-blue-md pt-3">Créateur</div>
                <div className="label-grey-md-normal">{`${data.creator?.firstName} ${data.creator?.lastName}`}</div>
              </div>
            </Col>
            <Col>
              <div className="box">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0ZM10 3C11.6569 3 13 4.34315 13 6C13 7.65685 11.6569 9 10 9C8.34315 9 7 7.65685 7 6C7 4.34315 8.34315 3 10 3ZM10 16.9868C12.2151 16.9868 14.2994 15.9384 15.62 14.16C15.8246 13.8609 15.8514 13.4745 15.69 13.15L15.46 12.68C14.9568 11.6531 13.9136 11.0015 12.77 11H7.23C6.07012 11.0012 5.01488 11.671 4.52 12.72L4.31 13.16C4.15251 13.4818 4.17921 13.8633 4.38 14.16C5.70056 15.9384 7.78493 16.9868 10 16.9868Z"
                    fill="#3367CD"
                  />
                </svg>
                <div className="label-blue-md pt-3">Entreprise</div>
                <div className="label-grey-md-normal">
                  {data.creator?.entreprise}
                </div>
              </div>
            </Col>
          </Col>
        </div>
      ) : (
        <div className="preview-content-header m-auto">
          <Row className="d-flex preview-title">
            <Col md={{ offset: 4 }}>
              <div className="label-white-xlg">{data?.title}</div>
            </Col>
          </Row>
          <Row className="d-flex preview-subject">
            <Col className="d-flex" md={{ offset: 4 }}>
              {data.subject.map((sub: any) => {
                return (
                  <Box
                    key={sub.id}
                    content={sub.label}
                    background="#ECF0FB"
                    color="#3367CD"
                  ></Box>
                );
              })}
            </Col>
          </Row>
          <Row className="d-flex preview-subject">
            <Col className="d-flex" md={{ offset: 4 }}>
              <svg
                width="18"
                height="15"
                viewBox="0 0 18 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8 9V2C8 0.89543 7.10457 0 6 0H2C0.89543 0 0 0.89543 0 2V6C0 7.10457 0.89543 8 2 8H5V9C5.01856 9.96862 4.34023 10.8113 3.39 11C3.1683 11.0498 3.0081 11.2429 3 11.47V13.47C2.99257 13.6252 3.05492 13.7756 3.17 13.88C3.27637 13.9748 3.41874 14.0186 3.56 14C6.10071 13.7137 8.01608 11.5567 8 9ZM12 0H16C17.1046 0 18 0.89543 18 2V9C18.011 11.5529 16.0969 13.7041 13.56 13.99C13.4187 14.0086 13.2764 13.9648 13.17 13.87C13.0629 13.7725 13.0013 13.6348 13 13.49V11.49C12.9989 11.2554 13.1611 11.0516 13.39 11C14.3402 10.8113 15.0186 9.96862 15 9V8H12C10.8954 8 10 7.10457 10 6V2C10 0.89543 10.8954 0 12 0Z"
                  fill="#ECF0FB"
                />
              </svg>
              <div className="label-white-lg pl-10">
                {" "}
                À propos de la formation
              </div>
            </Col>
          </Row>
          <Row className="d-flex preview-subject">
            <Col md={{ offset: 4 }}>
              {data?.description.replace(/<br\s*\/?>/gm, "\r\n").split(/[\n]+/).map((item: any, idx: any) => (
                <p key={idx} className="label-white-md">
                  {item}
                  <br />
                </p>
              ))}
            </Col>
          </Row>
          <Row className="d-flex preview-subject">
            <Col xs="6">
              <div className="box" style={{ top: "50%" }}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0ZM10 3C11.6569 3 13 4.34315 13 6C13 7.65685 11.6569 9 10 9C8.34315 9 7 7.65685 7 6C7 4.34315 8.34315 3 10 3ZM10 16.9868C12.2151 16.9868 14.2994 15.9384 15.62 14.16C15.8246 13.8609 15.8514 13.4745 15.69 13.15L15.46 12.68C14.9568 11.6531 13.9136 11.0015 12.77 11H7.23C6.07012 11.0012 5.01488 11.671 4.52 12.72L4.31 13.16C4.15251 13.4818 4.17921 13.8633 4.38 14.16C5.70056 15.9384 7.78493 16.9868 10 16.9868Z"
                    fill="#3367CD"
                  />
                </svg>
                <div className="label-blue-md pt-3">Créateur</div>
                <div className="label-grey-md-normal">{`${data.creator?.firstName} ${data.creator?.lastName}`}</div>
              </div>
            </Col>
            <Col xs="6">
              <div className="box" style={{ top: "50%" }}>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0ZM10 3C11.6569 3 13 4.34315 13 6C13 7.65685 11.6569 9 10 9C8.34315 9 7 7.65685 7 6C7 4.34315 8.34315 3 10 3ZM10 16.9868C12.2151 16.9868 14.2994 15.9384 15.62 14.16C15.8246 13.8609 15.8514 13.4745 15.69 13.15L15.46 12.68C14.9568 11.6531 13.9136 11.0015 12.77 11H7.23C6.07012 11.0012 5.01488 11.671 4.52 12.72L4.31 13.16C4.15251 13.4818 4.17921 13.8633 4.38 14.16C5.70056 15.9384 7.78493 16.9868 10 16.9868Z"
                    fill="#3367CD"
                  />
                </svg>
                <div className="label-blue-md pt-3">Entreprise</div>
                <div className="label-grey-md-normal">
                  {data.creator?.entreprise}
                </div>
              </div>
            </Col>
          </Row>
        </div>
      )}
      <div className="nav-wrapper" style={{ paddingTop: "5%" }}>
        <Col md="8" style={matches.small ? { marginLeft: 15 } : {}}>
          <Row className="d-flex preview-subject">
            <Col className="d-flex" md={{ offset: 4 }}>
              <Col className="d-flex">
                <div className="label-grey-md">Date : </div>
                <div className="label-blue-md">
                  {isToday(new Date(`${sectionData.date.slice(0, 10)}`))
                    ? `Aujourd’hui de ${format(
                        new Date(
                          `${sectionData.date.slice(0, 10)} ${
                            sectionData.startTimeHour
                          }:${sectionData.startTimeMinute}`
                        ),
                        "HH:mm",
                        {
                          locale: fr,
                        }
                      )} à ${format(
                        new Date(
                          `${sectionData.date.slice(0, 10)} ${
                            sectionData.endTimeHour
                          }:${sectionData.endTimeMinute}`
                        ),
                        "HH:mm",
                        {
                          locale: fr,
                        }
                      )}`
                    : `Le ${format(
                        new Date(`${sectionData.date.slice(0, 10)}`),
                        "dd/MM/yyyy",
                        {
                          locale: fr,
                        }
                      )} de ${format(
                        new Date(
                          `${sectionData.date.slice(0, 10)} ${
                            sectionData.startTimeHour
                          }:${sectionData.startTimeMinute}`
                        ),
                        "HH:mm",
                        {
                          locale: fr,
                        }
                      )} à ${format(
                        new Date(
                          `${sectionData.date.slice(0, 10)} ${
                            sectionData.endTimeHour
                          }:${sectionData.endTimeMinute}`
                        ),
                        "HH:mm",
                        {
                          locale: fr,
                        }
                      )}`}
                </div>
              </Col>
              <Col className="d-flex">
                <div className="label-grey-md">{data.subscribers>1 ? "Nombre de participants" : "Nombre de participant"} </div>
                <div className="label-black-nqt-sm">: {data.subscribers}</div>
              </Col>
            </Col>
          </Row>
          <Row style={{ paddingTop: 30, paddingBottom: 30 }}>
            <hr className="line" />
          </Row>
          {sectionData.type === "dig" && (
            <>
              <Row className="d-flex preview-subject">
                <Col className="d-flex" md={{ offset: 4 }}>
                  <svg
                    width="18"
                    height="15"
                    viewBox="0 0 18 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M8 9V2C8 0.89543 7.10457 0 6 0H2C0.89543 0 0 0.89543 0 2V6C0 7.10457 0.89543 8 2 8H5V9C5.01856 9.96862 4.34023 10.8113 3.39 11C3.1683 11.0498 3.0081 11.2429 3 11.47V13.47C2.99257 13.6252 3.05492 13.7756 3.17 13.88C3.27637 13.9748 3.41874 14.0186 3.56 14C6.10071 13.7137 8.01608 11.5567 8 9ZM12 0H16C17.1046 0 18 0.89543 18 2V9C18.011 11.5529 16.0969 13.7041 13.56 13.99C13.4187 14.0086 13.2764 13.9648 13.17 13.87C13.0629 13.7725 13.0013 13.6348 13 13.49V11.49C12.9989 11.2554 13.1611 11.0516 13.39 11C14.3402 10.8113 15.0186 9.96862 15 9V8H12C10.8954 8 10 7.10457 10 6V2C10 0.89543 10.8954 0 12 0Z"
                      fill="#3367CD"
                    />
                  </svg>
                  <div className="label-black-md pl-10">
                    Lien pour lancer la visio
                  </div>
                </Col>
              </Row>
              <Row className="d-flex preview-subject">
                <Col className="d-grid" md={{ offset: 4 }}>
                  {sectionData.section?.sectionDescription.replace(/<br\s*\/?>/gm, "\r\n").split(/[\n]+/).map((item: any, idx: any) => (
                    <div key={idx} className="label-grey-md pt-3">
                      {item}
                      <br />
                    </div>
                  ))}
                  <Col className="zoom-container" md="4">
                    <div>
                      <div className="zoom-title">Lancer le lien {getMeetingTool()}</div>
                      <div className="zoom-url">{sectionData.location}</div>
                    </div>
                    <a
                      href={sectionData.location}
                      style={{ marginLeft: "auto" }}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M2 11.5L2 12.5C2 12.7761 2.22386 13 2.5 13L18.67 13L14.22 17.44C14.1253 17.5339 14.0721 17.6617 14.0721 17.795C14.0721 17.9283 14.1253 18.0561 14.22 18.15L14.93 18.85C15.0239 18.9446 15.1517 18.9979 15.285 18.9979C15.4183 18.9979 15.5461 18.9446 15.64 18.85L21.78 12.72C21.9207 12.5795 21.9998 12.3888 22 12.19L22 11.81C21.9977 11.6116 21.9189 11.4217 21.78 11.28L15.64 5.14997C15.5461 5.05532 15.4183 5.00207 15.285 5.00207C15.1517 5.00207 15.0239 5.05532 14.93 5.14997L14.22 5.85997C14.1259 5.95214 14.0729 6.07828 14.0729 6.20997C14.0729 6.34166 14.1259 6.46781 14.22 6.55997L18.67 11L2.5 11C2.22386 11 2 11.2238 2 11.5Z"
                          fill="#3367CD"
                        />
                      </svg>
                    </a>
                  </Col>
                </Col>
              </Row>
              <Row style={{ paddingTop: 30, paddingBottom: 30 }}>
                <hr className="line" />
              </Row>
            </>
          )}
          {sectionData.type === "pres" && (
            <>
              <Row className="d-flex preview-subject">
                <Col className="d-flex" md={{ offset: 4 }}>
                  <svg
                    width="16"
                    height="19"
                    viewBox="0 0 16 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8 0C10.1217 0 12.1566 0.857906 13.6569 2.38499C15.1571 3.91207 16 5.98324 16 8.14286C16 11.514 13.4756 15.0462 8.53333 18.819C8.37947 18.9365 8.19233 19 8 19C7.80767 19 7.62053 18.9365 7.46667 18.819C2.52444 15.0462 0 11.514 0 8.14286C0 5.98324 0.842855 3.91207 2.34315 2.38499C3.84344 0.857906 5.87827 0 8 0ZM8 5.42857C7.29276 5.42857 6.61448 5.71454 6.11438 6.22357C5.61428 6.73259 5.33333 7.42298 5.33333 8.14286C5.33333 8.86273 5.61428 9.55312 6.11438 10.0621C6.61448 10.5712 7.29276 10.8571 8 10.8571C8.70724 10.8571 9.38552 10.5712 9.88562 10.0621C10.3857 9.55312 10.6667 8.86273 10.6667 8.14286C10.6667 7.42298 10.3857 6.73259 9.88562 6.22357C9.38552 5.71454 8.70724 5.42857 8 5.42857Z"
                      fill="#3367CD"
                    />
                  </svg>

                  <div className="label-black-md pl-10">
                    {" "}
                    Lieu de la formation
                  </div>
                </Col>
              </Row>
              <Row className="d-flex preview-subject">
                <Col className="d-grid" md={{ offset: 4 }}>
                  <div className="label-grey-md pt-3">
                    {sectionData.location}
                  </div>
                </Col>
              </Row>
              <Row style={{ paddingTop: 30, paddingBottom: 30 }}>
                <hr className="line" />
              </Row>
            </>
          )}
          <Row className="d-flex preview-subject mb-2">
            <Col className="d-flex" md={{ offset: 4 }}>
              <svg
                width="18"
                height="15"
                viewBox="0 0 18 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8 9V2C8 0.89543 7.10457 0 6 0H2C0.89543 0 0 0.89543 0 2V6C0 7.10457 0.89543 8 2 8H5V9C5.01856 9.96862 4.34023 10.8113 3.39 11C3.1683 11.0498 3.0081 11.2429 3 11.47V13.47C2.99257 13.6252 3.05492 13.7756 3.17 13.88C3.27637 13.9748 3.41874 14.0186 3.56 14C6.10071 13.7137 8.01608 11.5567 8 9ZM12 0H16C17.1046 0 18 0.89543 18 2V9C18.011 11.5529 16.0969 13.7041 13.56 13.99C13.4187 14.0086 13.2764 13.9648 13.17 13.87C13.0629 13.7725 13.0013 13.6348 13 13.49V11.49C12.9989 11.2554 13.1611 11.0516 13.39 11C14.3402 10.8113 15.0186 9.96862 15 9V8H12C10.8954 8 10 7.10457 10 6V2C10 0.89543 10.8954 0 12 0Z"
                  fill="#3367CD"
                />
              </svg>
              <div className="label-black-md pl-10">Code de validation</div>
            </Col>
            <Col md="8">
              <p className="label-grey-normal">
                Le créateur de la formation vous communiquera un code de validation pour confirmer votre présence.
              </p>
            </Col>
            {!hasPassed ? (
              <Col md="8" className="d-flex flex-row">
                <div className="iconOutlined label-primary-nqt-md px-3 me-2">
                  <LockIcon />
                </div>
                <div className="iconOutlined label-primary-nqt-md px-3 me-2">
                  <LockIcon />
                </div>
                <div className="iconOutlined label-primary-nqt-md px-3 me-2">
                  <LockIcon />
                </div>
                <div className="iconOutlined label-primary-nqt-md px-3">
                  <LockIcon />
                </div>
              </Col>
            ) : hasPassed && data.user_status_validation === "off" ? (
              <Col md="8">
                <Formik initialValues={initialValues} onSubmit={() => {}}>
                  {({ setFieldValue, setValues }) => (
                    <Form>
                      <div className="d-flex flex-row">
                        <Field
                          maxLength={1}
                          autoFocus
                          name="firstValue"
                          className={
                            isTruthy === "false"
                              ? "formControl me-2 label-pink-md"
                              : "formControl me-2 label-primary-md"
                          }
                          placeholder="_"
                          disabled={
                            attempts === 5 ||
                            isTruthy === "true" ||
                            codeValidation.length === 4
                          }
                          onChange={(ev: any) =>
                            handleChange(ev, setFieldValue, "firstValue")
                          }
                          style={{ padding: 3, textAlign: "center", width: 42 }}
                        />
                        <Field
                          maxLength={1}
                          name="secondValue"
                          disabled={
                            attempts === 5 ||
                            isTruthy === "true" ||
                            codeValidation.length === 4
                          }
                          className={
                            isTruthy === "false"
                              ? "formControl me-2 label-pink-md"
                              : "formControl me-2 label-primary-md"
                          }
                          placeholder="_"
                          onChange={(ev: any) =>
                            handleChange(ev, setFieldValue, "secondValue")
                          }
                          style={{ padding: 3, textAlign: "center", width: 42 }}
                        />
                        <Field
                          maxLength={1}
                          name="thirdValue"
                          disabled={
                            attempts === 5 ||
                            isTruthy === "true" ||
                            codeValidation.length === 4
                          }
                          className={
                            isTruthy === "false"
                              ? "formControl me-2 label-pink-md"
                              : "formControl me-2 label-primary-md"
                          }
                          placeholder="_"
                          onChange={(ev: any) =>
                            handleChange(ev, setFieldValue, "thirdValue")
                          }
                          style={{ padding: 3, textAlign: "center", width: 42 }}
                        />
                        <Field
                          maxLength={1}
                          name="fourthValue"
                          className={
                            isTruthy === "false"
                              ? "formControl me-2 label-pink-md"
                              : "formControl me-2 label-primary-md"
                          }
                          placeholder="_"
                          disabled={
                            attempts === 5 ||
                            isTruthy === "true" ||
                            codeValidation.length === 4
                          }
                          onChange={(ev: any) =>
                            handleChange(ev, setFieldValue, "fourthValue")
                          }
                          style={{ padding: 3, textAlign: "center", width: 42 }}
                        />
                        {attempts < 5 && isTruthy === "false" && (
                          <ReDoIcon
                            className="mt-3 pointer"
                            onClick={() => {
                              setValues(initialValues);
                              setCodeValidation("");
                              setIsTruthy("pending");
                            }}
                          />
                        )}
                      </div>
                      {attempts <= 5 && isTruthy === "false" && (
                        <p className="label-pink float-start mt-2">
                          X Code de validation incorrect : essai {attempts}/5
                        </p>
                      )}
                      {isTruthy === "true" && (
                        <p className="label-green float-start mt-2">
                          <DoneIcon /> Code de validation correct
                        </p>
                      )}
                    </Form>
                  )}
                </Formik>
              </Col>
            ) : data.user_status_validation === "on" ? (
              <Col md="8">
                <p className="label-green float-start mt-2">
                  <DoneIcon /> Vote Code de validation est validée avec succès
                </p>
              </Col>
            ) : data.user_status_validation === "blocked" ? (
              <Col md="8">
                <p className="label-pink float-start mt-2">
                  La validation de code a échoué.
                </p>
              </Col>
            ) : null}
          </Row>
          <Row className="d-flex preview-subject">
            <Col className="d-flex" md={{ offset: 4 }}>
              <svg
                width="18"
                height="15"
                viewBox="0 0 18 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8 9V2C8 0.89543 7.10457 0 6 0H2C0.89543 0 0 0.89543 0 2V6C0 7.10457 0.89543 8 2 8H5V9C5.01856 9.96862 4.34023 10.8113 3.39 11C3.1683 11.0498 3.0081 11.2429 3 11.47V13.47C2.99257 13.6252 3.05492 13.7756 3.17 13.88C3.27637 13.9748 3.41874 14.0186 3.56 14C6.10071 13.7137 8.01608 11.5567 8 9ZM12 0H16C17.1046 0 18 0.89543 18 2V9C18.011 11.5529 16.0969 13.7041 13.56 13.99C13.4187 14.0086 13.2764 13.9648 13.17 13.87C13.0629 13.7725 13.0013 13.6348 13 13.49V11.49C12.9989 11.2554 13.1611 11.0516 13.39 11C14.3402 10.8113 15.0186 9.96862 15 9V8H12C10.8954 8 10 7.10457 10 6V2C10 0.89543 10.8954 0 12 0Z"
                  fill="#3367CD"
                />
              </svg>
              <div className="label-black-md pl-10">
                {" "}
                Contenus à télécharger
              </div>
            </Col>
          </Row>
        </Col>
      </div>
      <div className="preview-content">
        <Col md="8" style={matches.small ? { marginLeft: 15 } : {}}>
          {sectionData.section.files.map((content: any, index: number) => {
            if (content.type === "upload") {
              return (
                <div className="pb-3" key={index}>
                  <Col className="preview-xls" md={{ offset: 2 }}>
                    <div>{getIcons(content.fileType)}</div>
                    <div className="d-grid">
                      <span>Télécharger le fichier {content.fileType}</span>
                      <span>{content.fileName}</span>
                    </div>
                    <a
                      href={content.file}
                      download={content.fileName}
                      style={{ marginLeft: "auto" }}
                    >
                      <svg
                        width="30"
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M15 20.0019C14.8343 20.0019 14.6759 19.9333 14.5625 19.8125L7.325 12.575C7.20668 12.4576 7.14013 12.2979 7.14013 12.1313C7.14013 11.9646 7.20668 11.8049 7.325 11.6875L7.575 11.4375C7.69259 11.3154 7.85552 11.2475 8.025 11.25H11.25V4.375C11.25 4.02982 11.5298 3.75 11.875 3.75H18.125C18.4702 3.75 18.75 4.02982 18.75 4.375V11.25H21.975C22.1445 11.2475 22.3074 11.3154 22.425 11.4375L22.675 11.6875C22.7933 11.8049 22.8599 11.9646 22.8599 12.1313C22.8599 12.2979 22.7933 12.4576 22.675 12.575L15.4375 19.8125C15.3241 19.9333 15.1657 20.0019 15 20.0019ZM23.75 24.375V23.125C23.75 22.7798 23.4702 22.5 23.125 22.5H6.875C6.52982 22.5 6.25 22.7798 6.25 23.125V24.375C6.25 24.7202 6.52982 25 6.875 25H23.125C23.4702 25 23.75 24.7202 23.75 24.375Z"
                          fill="#3367CD"
                        />
                      </svg>
                    </a>
                  </Col>
                </div>
              );
            }
            return null;
          })}
        </Col>
      </div>
      {data.feedback && (
        <Col md="8" style={matches.small ? { marginLeft: 15 } : {}}>
          <Row className="d-flex preview-subject">
            <Col className="d-flex" md={{ offset: 4 }}>
              <svg
                width="18"
                height="15"
                viewBox="0 0 18 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8 9V2C8 0.89543 7.10457 0 6 0H2C0.89543 0 0 0.89543 0 2V6C0 7.10457 0.89543 8 2 8H5V9C5.01856 9.96862 4.34023 10.8113 3.39 11C3.1683 11.0498 3.0081 11.2429 3 11.47V13.47C2.99257 13.6252 3.05492 13.7756 3.17 13.88C3.27637 13.9748 3.41874 14.0186 3.56 14C6.10071 13.7137 8.01608 11.5567 8 9ZM12 0H16C17.1046 0 18 0.89543 18 2V9C18.011 11.5529 16.0969 13.7041 13.56 13.99C13.4187 14.0086 13.2764 13.9648 13.17 13.87C13.0629 13.7725 13.0013 13.6348 13 13.49V11.49C12.9989 11.2554 13.1611 11.0516 13.39 11C14.3402 10.8113 15.0186 9.96862 15 9V8H12C10.8954 8 10 7.10457 10 6V2C10 0.89543 10.8954 0 12 0Z"
                  fill="#3367CD"
                />
              </svg>
              <div className="label-black-md pl-10"> Feedbacks</div>
            </Col>
          </Row>
          <Row className="d-flex preview-subject">
            <Col className="d-grid" md={{ offset: 4 }}>
              <div className="label-grey-md pt-3">
                À la fin de la formation, pensez à revenir faire votre feedback,
                qui sera visible uniquement par le créateur. Cela lui permet de savoir comment s’est passée sa formation.
              </div>
              {data.feedback?.enable === false && (
                <Col className="feedback-container">
                  <Col md="4">
                    <div
                      className="d-flex"
                      data-tip="La formation n’est pas terminée."
                    >
                      {" "}
                      <svg
                        width="150"
                        height="30"
                        viewBox="0 0 150 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.0009 21.5875L20.1884 24.725C21.1384 25.3 22.3009 24.45 22.0509 23.375L20.6759 17.475L25.2634 13.5C26.1009 12.775 25.6509 11.4 24.5509 11.3125L18.5134 10.8L16.1509 5.22501C15.7259 4.21251 14.2759 4.21251 13.8509 5.22501L11.4884 10.7875L5.45088 11.3C4.35088 11.3875 3.90088 12.7625 4.73838 13.4875L9.32588 17.4625L7.95088 23.3625C7.70088 24.4375 8.86338 25.2875 9.81338 24.7125L15.0009 21.5875Z"
                          fill="#BDBDBD"
                        />
                        <path
                          d="M45.0009 21.5875L50.1884 24.725C51.1384 25.3 52.3009 24.45 52.0509 23.375L50.6759 17.475L55.2634 13.5C56.1009 12.775 55.6509 11.4 54.5509 11.3125L48.5134 10.8L46.1509 5.22501C45.7259 4.21251 44.2759 4.21251 43.8509 5.22501L41.4884 10.7875L35.4509 11.3C34.3509 11.3875 33.9009 12.7625 34.7384 13.4875L39.3259 17.4625L37.9509 23.3625C37.7009 24.4375 38.8634 25.2875 39.8134 24.7125L45.0009 21.5875Z"
                          fill="#BDBDBD"
                        />
                        <path
                          d="M75.0009 21.5875L80.1884 24.725C81.1384 25.3 82.3009 24.45 82.0509 23.375L80.6759 17.475L85.2634 13.5C86.1009 12.775 85.6509 11.4 84.5509 11.3125L78.5134 10.8L76.1509 5.22501C75.7259 4.21251 74.2759 4.21251 73.8509 5.22501L71.4884 10.7875L65.4509 11.3C64.3509 11.3875 63.9009 12.7625 64.7384 13.4875L69.3259 17.4625L67.9509 23.3625C67.7009 24.4375 68.8634 25.2875 69.8134 24.7125L75.0009 21.5875Z"
                          fill="#BDBDBD"
                        />
                        <path
                          d="M105.001 21.5875L110.188 24.725C111.138 25.3 112.301 24.45 112.051 23.375L110.676 17.475L115.263 13.5C116.101 12.775 115.651 11.4 114.551 11.3125L108.513 10.8L106.151 5.22501C105.726 4.21251 104.276 4.21251 103.851 5.22501L101.488 10.7875L95.4509 11.3C94.3509 11.3875 93.9009 12.7625 94.7384 13.4875L99.3259 17.4625L97.9509 23.3625C97.7009 24.4375 98.8634 25.2875 99.8134 24.7125L105.001 21.5875Z"
                          fill="#BDBDBD"
                        />
                        <path
                          d="M135.001 21.5875L140.188 24.725C141.138 25.3 142.301 24.45 142.051 23.375L140.676 17.475L145.263 13.5C146.101 12.775 145.651 11.4 144.551 11.3125L138.513 10.8L136.151 5.22501C135.726 4.21251 134.276 4.21251 133.851 5.22501L131.488 10.7875L125.451 11.3C124.351 11.3875 123.901 12.7625 124.738 13.4875L129.326 17.4625L127.951 23.3625C127.701 24.4375 128.863 25.2875 129.813 24.7125L135.001 21.5875Z"
                          fill="#BDBDBD"
                        />
                      </svg>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.9993 9.33332H15.3327V7.99999C15.3327 6.15999 13.8393 4.66666 11.9993 4.66666C10.1593 4.66666 8.66602 6.15999 8.66602 7.99999V9.33332H7.99935C7.26602 9.33332 6.66602 9.93332 6.66602 10.6667V17.3333C6.66602 18.0667 7.26602 18.6667 7.99935 18.6667H15.9993C16.7327 18.6667 17.3327 18.0667 17.3327 17.3333V10.6667C17.3327 9.93332 16.7327 9.33332 15.9993 9.33332ZM11.9993 15.3333C11.266 15.3333 10.666 14.7333 10.666 14C10.666 13.2667 11.266 12.6667 11.9993 12.6667C12.7327 12.6667 13.3327 13.2667 13.3327 14C13.3327 14.7333 12.7327 15.3333 11.9993 15.3333ZM14.066 9.33332H9.93268V7.99999C9.93268 6.85999 10.8593 5.93332 11.9993 5.93332C13.1393 5.93332 14.066 6.85999 14.066 7.99999V9.33332Z"
                          fill="#BDBDBD"
                        />
                      </svg>
                    </div>
                    <ReactTooltip />
                  </Col>
                  <Col>
                    <svg
                      width="835"
                      height="84"
                      viewBox="0 0 835 84"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="0.5"
                        y="0.5"
                        width="834"
                        height="83"
                        rx="7.5"
                        fill="white"
                        stroke="#F0F0F0"
                      />
                      <path
                        d="M802.999 39.3333H802.333V38C802.333 36.16 800.839 34.6667 798.999 34.6667C797.159 34.6667 795.666 36.16 795.666 38V39.3333H794.999C794.266 39.3333 793.666 39.9333 793.666 40.6667V47.3333C793.666 48.0667 794.266 48.6667 794.999 48.6667H802.999C803.733 48.6667 804.333 48.0667 804.333 47.3333V40.6667C804.333 39.9333 803.733 39.3333 802.999 39.3333ZM798.999 45.3333C798.266 45.3333 797.666 44.7333 797.666 44C797.666 43.2667 798.266 42.6667 798.999 42.6667C799.733 42.6667 800.333 43.2667 800.333 44C800.333 44.7333 799.733 45.3333 798.999 45.3333ZM801.066 39.3333H796.933V38C796.933 36.86 797.859 35.9333 798.999 35.9333C800.139 35.9333 801.066 36.86 801.066 38V39.3333Z"
                        fill="#BDBDBD"
                      />

                      <svg y="17" x="17" width="180" height="11.205" viewBox="0 0 204.81 11.205" xmlns="http://www.w3.org/2000/svg">
                        <path fill="#8D8D8D" d="M 112.365 11.025 L 111.015 11.025 L 111.015 3.225 L 112.32 3.225 L 112.32 4.53 Q 112.74 3.9 113.385 3.473 A 2.581 2.581 0 0 1 114.765 3.046 A 3.128 3.128 0 0 1 114.855 3.045 Q 115.785 3.045 116.377 3.495 Q 116.97 3.945 117.21 4.695 Q 117.675 4.005 118.312 3.525 A 2.35 2.35 0 0 1 119.331 3.093 A 3.217 3.217 0 0 1 119.895 3.045 A 3.216 3.216 0 0 1 120.628 3.123 Q 121.166 3.249 121.539 3.578 A 1.949 1.949 0 0 1 121.792 3.848 A 2.849 2.849 0 0 1 122.304 4.938 Q 122.401 5.339 122.413 5.805 A 5.189 5.189 0 0 1 122.415 5.94 L 122.415 11.025 L 121.065 11.025 L 121.065 6.045 Q 121.065 5.235 120.69 4.733 A 1.196 1.196 0 0 0 119.818 4.238 A 1.602 1.602 0 0 0 119.655 4.23 A 1.789 1.789 0 0 0 118.641 4.549 A 2.399 2.399 0 0 0 118.403 4.733 Q 117.825 5.235 117.39 5.91 L 117.39 11.025 L 116.04 11.025 L 116.04 6.045 Q 116.04 5.235 115.665 4.733 A 1.196 1.196 0 0 0 114.793 4.238 A 1.602 1.602 0 0 0 114.63 4.23 A 1.803 1.803 0 0 0 113.682 4.504 A 2.437 2.437 0 0 0 113.385 4.718 Q 112.8 5.205 112.365 5.865 L 112.365 11.025 Z M 126.09 11.025 L 124.74 11.025 L 124.74 3.225 L 126.045 3.225 L 126.045 4.53 Q 126.465 3.9 127.11 3.473 A 2.581 2.581 0 0 1 128.49 3.046 A 3.128 3.128 0 0 1 128.58 3.045 Q 129.51 3.045 130.102 3.495 Q 130.695 3.945 130.935 4.695 Q 131.4 4.005 132.037 3.525 A 2.35 2.35 0 0 1 133.056 3.093 A 3.217 3.217 0 0 1 133.62 3.045 A 3.216 3.216 0 0 1 134.353 3.123 Q 134.891 3.249 135.264 3.578 A 1.949 1.949 0 0 1 135.517 3.848 A 2.849 2.849 0 0 1 136.029 4.938 Q 136.126 5.339 136.138 5.805 A 5.189 5.189 0 0 1 136.14 5.94 L 136.14 11.025 L 134.79 11.025 L 134.79 6.045 Q 134.79 5.235 134.415 4.733 A 1.196 1.196 0 0 0 133.543 4.238 A 1.602 1.602 0 0 0 133.38 4.23 A 1.789 1.789 0 0 0 132.366 4.549 A 2.399 2.399 0 0 0 132.128 4.733 Q 131.55 5.235 131.115 5.91 L 131.115 11.025 L 129.765 11.025 L 129.765 6.045 Q 129.765 5.235 129.39 4.733 A 1.196 1.196 0 0 0 128.518 4.238 A 1.602 1.602 0 0 0 128.355 4.23 A 1.803 1.803 0 0 0 127.407 4.504 A 2.437 2.437 0 0 0 127.11 4.718 Q 126.525 5.205 126.09 5.865 L 126.09 11.025 Z M 147.975 11.025 L 146.625 11.025 L 146.625 3.225 L 147.93 3.225 L 147.93 4.53 Q 148.35 3.9 149.002 3.473 A 2.597 2.597 0 0 1 150.068 3.079 A 3.394 3.394 0 0 1 150.555 3.045 A 3.484 3.484 0 0 1 151.315 3.123 Q 151.816 3.235 152.182 3.509 A 1.989 1.989 0 0 1 152.527 3.84 A 2.761 2.761 0 0 1 153.068 4.947 Q 153.18 5.4 153.18 5.94 L 153.18 11.025 L 151.83 11.025 L 151.83 6.09 A 2.89 2.89 0 0 0 151.779 5.529 Q 151.687 5.067 151.432 4.74 Q 151.035 4.23 150.33 4.23 A 1.968 1.968 0 0 0 149.303 4.525 A 2.603 2.603 0 0 0 149.025 4.718 Q 148.41 5.205 147.975 5.865 L 147.975 11.025 Z M 48.075 11.025 L 42.045 11.025 L 42.045 9.96 L 46.35 4.395 L 42.135 4.395 L 42.135 3.225 L 48 3.225 L 48 4.26 L 43.71 9.825 L 48.075 9.825 L 48.075 11.025 Z M 19.845 10.395 L 20.415 9.27 A 2.784 2.784 0 0 0 20.887 9.589 Q 21.118 9.715 21.393 9.816 A 4.326 4.326 0 0 0 21.398 9.818 A 3.611 3.611 0 0 0 22.539 10.033 A 4.12 4.12 0 0 0 22.665 10.035 Q 23.474 10.035 23.9 9.778 A 1.161 1.161 0 0 0 23.933 9.758 A 1.117 1.117 0 0 0 24.163 9.564 A 0.758 0.758 0 0 0 24.36 9.045 A 1.068 1.068 0 0 0 24.313 8.723 A 0.932 0.932 0 0 0 24.203 8.49 Q 24.045 8.25 23.625 8.018 Q 23.246 7.808 22.56 7.567 A 15.54 15.54 0 0 0 22.41 7.515 A 6.992 6.992 0 0 1 21.75 7.254 Q 21.433 7.108 21.182 6.944 A 2.9 2.9 0 0 1 20.767 6.623 A 1.699 1.699 0 0 1 20.273 5.723 A 2.519 2.519 0 0 1 20.22 5.19 A 1.818 1.818 0 0 1 20.812 3.838 A 2.619 2.619 0 0 1 21.008 3.668 Q 21.795 3.045 23.19 3.045 Q 23.928 3.045 24.506 3.197 A 3.795 3.795 0 0 1 24.525 3.203 A 5.815 5.815 0 0 1 25.145 3.406 A 4.667 4.667 0 0 1 25.575 3.6 L 25.2 4.71 Q 24.795 4.47 24.277 4.32 A 3.754 3.754 0 0 0 23.605 4.193 A 4.776 4.776 0 0 0 23.13 4.17 A 3.095 3.095 0 0 0 22.69 4.199 Q 22.227 4.266 21.945 4.485 A 1.398 1.398 0 0 0 21.741 4.676 Q 21.54 4.911 21.54 5.175 A 0.738 0.738 0 0 0 21.764 5.708 A 1.062 1.062 0 0 0 21.855 5.79 Q 22.165 6.041 23.055 6.335 A 12.669 12.669 0 0 0 23.085 6.345 A 10.163 10.163 0 0 1 23.844 6.63 Q 24.566 6.937 24.98 7.279 A 2.242 2.242 0 0 1 25.155 7.44 A 2.04 2.04 0 0 1 25.738 8.827 A 2.684 2.684 0 0 1 25.74 8.94 Q 25.74 9.99 24.893 10.598 A 3.008 3.008 0 0 1 23.936 11.044 Q 23.355 11.205 22.62 11.205 A 5.998 5.998 0 0 1 21.741 11.143 A 4.642 4.642 0 0 1 21.022 10.98 A 4.633 4.633 0 0 1 20.446 10.757 Q 20.149 10.618 19.912 10.445 A 2.734 2.734 0 0 1 19.845 10.395 Z M 26.865 10.395 L 27.435 9.27 A 2.784 2.784 0 0 0 27.907 9.589 Q 28.138 9.715 28.413 9.816 A 4.326 4.326 0 0 0 28.418 9.818 A 3.611 3.611 0 0 0 29.559 10.033 A 4.12 4.12 0 0 0 29.685 10.035 Q 30.494 10.035 30.92 9.778 A 1.161 1.161 0 0 0 30.953 9.758 A 1.117 1.117 0 0 0 31.183 9.564 A 0.758 0.758 0 0 0 31.38 9.045 A 1.068 1.068 0 0 0 31.333 8.723 A 0.932 0.932 0 0 0 31.223 8.49 Q 31.065 8.25 30.645 8.018 Q 30.266 7.808 29.58 7.567 A 15.54 15.54 0 0 0 29.43 7.515 A 6.992 6.992 0 0 1 28.77 7.254 Q 28.453 7.108 28.202 6.944 A 2.9 2.9 0 0 1 27.787 6.623 A 1.699 1.699 0 0 1 27.293 5.723 A 2.519 2.519 0 0 1 27.24 5.19 A 1.818 1.818 0 0 1 27.832 3.838 A 2.619 2.619 0 0 1 28.028 3.668 Q 28.815 3.045 30.21 3.045 Q 30.948 3.045 31.526 3.197 A 3.795 3.795 0 0 1 31.545 3.203 A 5.815 5.815 0 0 1 32.165 3.406 A 4.667 4.667 0 0 1 32.595 3.6 L 32.22 4.71 Q 31.815 4.47 31.297 4.32 A 3.754 3.754 0 0 0 30.625 4.193 A 4.776 4.776 0 0 0 30.15 4.17 A 3.095 3.095 0 0 0 29.71 4.199 Q 29.247 4.266 28.965 4.485 A 1.398 1.398 0 0 0 28.761 4.676 Q 28.56 4.911 28.56 5.175 A 0.738 0.738 0 0 0 28.784 5.708 A 1.062 1.062 0 0 0 28.875 5.79 Q 29.185 6.041 30.075 6.335 A 12.669 12.669 0 0 0 30.105 6.345 A 10.163 10.163 0 0 1 30.864 6.63 Q 31.586 6.937 32 7.279 A 2.242 2.242 0 0 1 32.175 7.44 A 2.04 2.04 0 0 1 32.758 8.827 A 2.684 2.684 0 0 1 32.76 8.94 Q 32.76 9.99 31.912 10.598 A 3.008 3.008 0 0 1 30.956 11.044 Q 30.375 11.205 29.64 11.205 A 5.998 5.998 0 0 1 28.761 11.143 A 4.642 4.642 0 0 1 28.042 10.98 A 4.633 4.633 0 0 1 27.466 10.757 Q 27.169 10.618 26.932 10.445 A 2.734 2.734 0 0 1 26.865 10.395 Z M 40.875 7.68 L 35.415 7.68 A 3.613 3.613 0 0 0 35.586 8.434 Q 35.764 8.943 36.096 9.304 A 2.247 2.247 0 0 0 36.18 9.39 A 2.122 2.122 0 0 0 37.324 9.962 A 3.003 3.003 0 0 0 37.845 10.005 Q 38.52 10.005 39.06 9.863 Q 39.6 9.72 40.095 9.495 L 40.41 10.65 A 6.115 6.115 0 0 1 39.76 10.894 A 7.779 7.779 0 0 1 39.195 11.048 A 5.837 5.837 0 0 1 38.431 11.17 A 7.804 7.804 0 0 1 37.68 11.205 A 4.248 4.248 0 0 1 36.518 11.054 A 3.166 3.166 0 0 1 35.018 10.133 Q 34.146 9.182 34.048 7.552 A 7.069 7.069 0 0 1 34.035 7.125 A 5.304 5.304 0 0 1 34.16 5.952 A 4.326 4.326 0 0 1 34.478 5.033 A 3.696 3.696 0 0 1 35.23 3.97 A 3.433 3.433 0 0 1 35.715 3.578 Q 36.51 3.045 37.56 3.045 Q 38.578 3.045 39.283 3.444 A 2.582 2.582 0 0 1 39.427 3.533 Q 40.17 4.02 40.545 4.845 A 4.228 4.228 0 0 1 40.909 6.325 A 5.015 5.015 0 0 1 40.92 6.66 A 11.281 11.281 0 0 1 40.876 7.665 A 10.23 10.23 0 0 1 40.875 7.68 Z M 88.77 7.68 L 83.31 7.68 A 3.613 3.613 0 0 0 83.481 8.434 Q 83.659 8.943 83.991 9.304 A 2.247 2.247 0 0 0 84.075 9.39 A 2.122 2.122 0 0 0 85.219 9.962 A 3.003 3.003 0 0 0 85.74 10.005 Q 86.415 10.005 86.955 9.863 Q 87.495 9.72 87.99 9.495 L 88.305 10.65 A 6.115 6.115 0 0 1 87.655 10.894 A 7.779 7.779 0 0 1 87.09 11.048 A 5.837 5.837 0 0 1 86.326 11.17 A 7.804 7.804 0 0 1 85.575 11.205 A 4.248 4.248 0 0 1 84.413 11.054 A 3.166 3.166 0 0 1 82.913 10.133 Q 82.041 9.182 81.943 7.552 A 7.069 7.069 0 0 1 81.93 7.125 A 5.304 5.304 0 0 1 82.055 5.952 A 4.326 4.326 0 0 1 82.373 5.033 A 3.696 3.696 0 0 1 83.125 3.97 A 3.433 3.433 0 0 1 83.61 3.578 Q 84.405 3.045 85.455 3.045 Q 86.473 3.045 87.178 3.444 A 2.582 2.582 0 0 1 87.322 3.533 Q 88.065 4.02 88.44 4.845 A 4.228 4.228 0 0 1 88.804 6.325 A 5.015 5.015 0 0 1 88.815 6.66 A 11.281 11.281 0 0 1 88.771 7.665 A 10.23 10.23 0 0 1 88.77 7.68 Z M 144.78 7.68 L 139.32 7.68 A 3.613 3.613 0 0 0 139.491 8.434 Q 139.669 8.943 140.001 9.304 A 2.247 2.247 0 0 0 140.085 9.39 A 2.122 2.122 0 0 0 141.229 9.962 A 3.003 3.003 0 0 0 141.75 10.005 Q 142.425 10.005 142.965 9.863 Q 143.505 9.72 144 9.495 L 144.315 10.65 A 6.115 6.115 0 0 1 143.665 10.894 A 7.779 7.779 0 0 1 143.1 11.048 A 5.837 5.837 0 0 1 142.336 11.17 A 7.804 7.804 0 0 1 141.585 11.205 A 4.248 4.248 0 0 1 140.423 11.054 A 3.166 3.166 0 0 1 138.923 10.133 Q 138.051 9.182 137.953 7.552 A 7.069 7.069 0 0 1 137.94 7.125 A 5.304 5.304 0 0 1 138.065 5.952 A 4.326 4.326 0 0 1 138.383 5.033 A 3.696 3.696 0 0 1 139.135 3.97 A 3.433 3.433 0 0 1 139.62 3.578 Q 140.415 3.045 141.465 3.045 Q 142.483 3.045 143.188 3.444 A 2.582 2.582 0 0 1 143.332 3.533 Q 144.075 4.02 144.45 4.845 A 4.228 4.228 0 0 1 144.814 6.325 A 5.015 5.015 0 0 1 144.825 6.66 A 11.281 11.281 0 0 1 144.781 7.665 A 10.23 10.23 0 0 1 144.78 7.68 Z M 186.015 7.68 L 180.555 7.68 A 3.613 3.613 0 0 0 180.726 8.434 Q 180.904 8.943 181.236 9.304 A 2.247 2.247 0 0 0 181.32 9.39 A 2.122 2.122 0 0 0 182.464 9.962 A 3.003 3.003 0 0 0 182.985 10.005 Q 183.66 10.005 184.2 9.863 Q 184.74 9.72 185.235 9.495 L 185.55 10.65 A 6.115 6.115 0 0 1 184.9 10.894 A 7.779 7.779 0 0 1 184.335 11.048 A 5.837 5.837 0 0 1 183.571 11.17 A 7.804 7.804 0 0 1 182.82 11.205 A 4.248 4.248 0 0 1 181.658 11.054 A 3.166 3.166 0 0 1 180.158 10.133 Q 179.286 9.182 179.188 7.552 A 7.069 7.069 0 0 1 179.175 7.125 A 5.304 5.304 0 0 1 179.3 5.952 A 4.326 4.326 0 0 1 179.618 5.033 A 3.696 3.696 0 0 1 180.37 3.97 A 3.433 3.433 0 0 1 180.855 3.578 Q 181.65 3.045 182.7 3.045 Q 183.718 3.045 184.423 3.444 A 2.582 2.582 0 0 1 184.567 3.533 Q 185.31 4.02 185.685 4.845 A 4.228 4.228 0 0 1 186.049 6.325 A 5.015 5.015 0 0 1 186.06 6.66 A 11.281 11.281 0 0 1 186.016 7.665 A 10.23 10.23 0 0 1 186.015 7.68 Z M 57.795 11.025 L 56.385 11.025 L 53.25 3.585 L 54.48 3.075 L 57.135 9.495 L 59.79 3.075 L 60.945 3.585 L 57.795 11.025 Z M 71.265 8.34 L 71.265 4.68 L 69.915 4.68 L 69.915 3.51 L 71.295 3.51 L 71.58 1.05 L 72.615 1.05 L 72.615 3.51 L 74.775 3.51 L 74.775 4.68 L 72.615 4.68 L 72.615 8.445 Q 72.615 9.216 72.904 9.575 A 0.833 0.833 0 0 0 72.983 9.66 Q 73.35 10.005 73.86 10.005 Q 74.235 10.005 74.572 9.885 A 3.86 3.86 0 0 0 75.049 9.68 A 3.415 3.415 0 0 0 75.195 9.6 L 75.57 10.68 A 2.782 2.782 0 0 1 75.327 10.809 Q 75.207 10.865 75.065 10.921 A 6.505 6.505 0 0 1 74.76 11.033 Q 74.25 11.205 73.695 11.205 A 3.401 3.401 0 0 1 73.677 11.205 Q 72.565 11.199 71.917 10.463 A 2.417 2.417 0 0 1 71.433 9.577 Q 71.319 9.213 71.282 8.772 A 5.217 5.217 0 0 1 71.265 8.34 Z M 155.805 8.34 L 155.805 4.68 L 154.455 4.68 L 154.455 3.51 L 155.835 3.51 L 156.12 1.05 L 157.155 1.05 L 157.155 3.51 L 159.315 3.51 L 159.315 4.68 L 157.155 4.68 L 157.155 8.445 Q 157.155 9.216 157.444 9.575 A 0.833 0.833 0 0 0 157.523 9.66 Q 157.89 10.005 158.4 10.005 Q 158.775 10.005 159.112 9.885 A 3.86 3.86 0 0 0 159.589 9.68 A 3.415 3.415 0 0 0 159.735 9.6 L 160.11 10.68 A 2.782 2.782 0 0 1 159.867 10.809 Q 159.747 10.865 159.605 10.921 A 6.505 6.505 0 0 1 159.3 11.033 Q 158.79 11.205 158.235 11.205 A 3.401 3.401 0 0 1 158.217 11.205 Q 157.105 11.199 156.457 10.463 A 2.417 2.417 0 0 1 155.973 9.577 Q 155.859 9.213 155.822 8.772 A 5.217 5.217 0 0 1 155.805 8.34 Z M 6.24 11.025 L 0 11.025 L 0 0.525 L 1.425 0.525 L 1.425 9.75 L 6.24 9.75 L 6.24 11.025 Z M 100.5 3.51 L 100.095 4.65 A 4.563 4.563 0 0 0 99.659 4.459 A 3.513 3.513 0 0 0 99.293 4.343 A 3.081 3.081 0 0 0 98.836 4.264 A 3.953 3.953 0 0 0 98.445 4.245 A 2.383 2.383 0 0 0 97.357 4.491 A 2.42 2.42 0 0 0 96.683 5.003 A 2.51 2.51 0 0 0 96.088 6.106 Q 95.97 6.553 95.97 7.095 A 3.779 3.779 0 0 0 96.076 8.004 A 3.218 3.218 0 0 0 96.27 8.565 A 2.785 2.785 0 0 0 96.707 9.252 A 2.441 2.441 0 0 0 97.102 9.615 A 2.02 2.02 0 0 0 98.178 9.999 A 2.536 2.536 0 0 0 98.355 10.005 A 4.263 4.263 0 0 0 98.791 9.984 Q 99.006 9.962 99.19 9.917 A 2.262 2.262 0 0 0 99.33 9.878 Q 99.733 9.751 100.196 9.512 A 7.912 7.912 0 0 0 100.2 9.51 L 100.62 10.65 A 4.281 4.281 0 0 1 99.927 10.951 A 5.144 5.144 0 0 1 99.577 11.055 Q 99 11.205 98.265 11.205 A 4.021 4.021 0 0 1 97.209 11.072 A 3.311 3.311 0 0 1 96.323 10.688 Q 95.49 10.17 95.04 9.248 A 4.404 4.404 0 0 1 94.644 7.926 A 5.703 5.703 0 0 1 94.59 7.125 Q 94.59 6 95.047 5.07 Q 95.505 4.14 96.36 3.593 Q 97.215 3.045 98.37 3.045 A 6.196 6.196 0 0 1 98.917 3.068 Q 99.25 3.098 99.532 3.165 Q 100.035 3.285 100.5 3.51 Z M 201.495 3.51 L 201.09 4.65 A 4.563 4.563 0 0 0 200.654 4.459 A 3.513 3.513 0 0 0 200.288 4.343 A 3.081 3.081 0 0 0 199.831 4.264 A 3.953 3.953 0 0 0 199.44 4.245 A 2.383 2.383 0 0 0 198.352 4.491 A 2.42 2.42 0 0 0 197.678 5.003 A 2.51 2.51 0 0 0 197.083 6.106 Q 196.965 6.553 196.965 7.095 A 3.779 3.779 0 0 0 197.071 8.004 A 3.218 3.218 0 0 0 197.265 8.565 A 2.785 2.785 0 0 0 197.702 9.252 A 2.441 2.441 0 0 0 198.097 9.615 A 2.02 2.02 0 0 0 199.173 9.999 A 2.536 2.536 0 0 0 199.35 10.005 A 4.263 4.263 0 0 0 199.786 9.984 Q 200.001 9.962 200.185 9.917 A 2.262 2.262 0 0 0 200.325 9.878 Q 200.728 9.751 201.191 9.512 A 7.912 7.912 0 0 0 201.195 9.51 L 201.615 10.65 A 4.281 4.281 0 0 1 200.922 10.951 A 5.144 5.144 0 0 1 200.572 11.055 Q 199.995 11.205 199.26 11.205 A 4.021 4.021 0 0 1 198.204 11.072 A 3.311 3.311 0 0 1 197.318 10.688 Q 196.485 10.17 196.035 9.248 A 4.404 4.404 0 0 1 195.639 7.926 A 5.703 5.703 0 0 1 195.585 7.125 Q 195.585 6 196.042 5.07 Q 196.5 4.14 197.355 3.593 Q 198.21 3.045 199.365 3.045 A 6.196 6.196 0 0 1 199.912 3.068 Q 200.245 3.098 200.527 3.165 Q 201.03 3.285 201.495 3.51 Z M 12.855 3.855 L 12.855 3.225 L 14.085 3.225 L 14.085 9.135 A 1.822 1.822 0 0 0 14.1 9.38 Q 14.15 9.746 14.362 9.878 Q 14.64 10.05 14.97 10.05 L 14.685 11.1 A 2.658 2.658 0 0 1 14.045 11.029 Q 13.171 10.812 12.945 9.93 A 3.196 3.196 0 0 1 12.479 10.444 A 4.275 4.275 0 0 1 12.008 10.808 Q 11.415 11.205 10.5 11.205 Q 9.525 11.205 8.73 10.71 Q 7.935 10.215 7.463 9.308 A 4.084 4.084 0 0 1 7.068 8.116 A 5.497 5.497 0 0 1 6.99 7.17 A 4.971 4.971 0 0 1 7.14 5.93 A 4.195 4.195 0 0 1 7.462 5.07 Q 7.935 4.14 8.768 3.593 A 3.345 3.345 0 0 1 10.447 3.052 A 4.108 4.108 0 0 1 10.68 3.045 A 3.388 3.388 0 0 1 11.399 3.119 A 2.805 2.805 0 0 1 11.903 3.278 A 3.9 3.9 0 0 1 12.546 3.622 A 3.315 3.315 0 0 1 12.855 3.855 Z M 166.5 3.855 L 166.5 3.225 L 167.73 3.225 L 167.73 9.135 A 1.822 1.822 0 0 0 167.745 9.38 Q 167.795 9.746 168.007 9.878 Q 168.285 10.05 168.615 10.05 L 168.33 11.1 A 2.658 2.658 0 0 1 167.69 11.029 Q 166.816 10.812 166.59 9.93 A 3.196 3.196 0 0 1 166.124 10.444 A 4.275 4.275 0 0 1 165.653 10.808 Q 165.06 11.205 164.145 11.205 Q 163.17 11.205 162.375 10.71 Q 161.58 10.215 161.107 9.308 A 4.084 4.084 0 0 1 160.713 8.116 A 5.497 5.497 0 0 1 160.635 7.17 A 4.971 4.971 0 0 1 160.785 5.93 A 4.195 4.195 0 0 1 161.107 5.07 Q 161.58 4.14 162.412 3.593 A 3.345 3.345 0 0 1 164.092 3.052 A 4.108 4.108 0 0 1 164.325 3.045 A 3.388 3.388 0 0 1 165.044 3.119 A 2.805 2.805 0 0 1 165.548 3.278 A 3.9 3.9 0 0 1 166.191 3.622 A 3.315 3.315 0 0 1 166.5 3.855 Z M 78.27 11.025 L 76.92 11.025 L 76.92 3.225 L 78.225 3.225 L 78.225 4.92 Q 78.42 4.425 78.75 3.998 Q 79.08 3.57 79.575 3.308 A 2.223 2.223 0 0 1 80.277 3.079 A 2.919 2.919 0 0 1 80.73 3.045 Q 80.955 3.045 81.18 3.068 A 2.846 2.846 0 0 1 81.338 3.088 Q 81.413 3.099 81.477 3.114 A 1.322 1.322 0 0 1 81.555 3.135 L 81.15 4.53 A 1.464 1.464 0 0 0 80.828 4.438 Q 80.679 4.413 80.51 4.41 A 2.487 2.487 0 0 0 80.475 4.41 A 1.944 1.944 0 0 0 79.481 4.687 A 2.342 2.342 0 0 0 79.417 4.725 Q 78.918 5.038 78.597 5.691 A 3.416 3.416 0 0 0 78.592 5.7 Q 78.27 6.36 78.27 7.38 L 78.27 11.025 Z M 175.515 11.025 L 174.165 11.025 L 174.165 3.225 L 175.47 3.225 L 175.47 4.92 Q 175.665 4.425 175.995 3.998 Q 176.325 3.57 176.82 3.308 A 2.223 2.223 0 0 1 177.522 3.079 A 2.919 2.919 0 0 1 177.975 3.045 Q 178.2 3.045 178.425 3.068 A 2.846 2.846 0 0 1 178.583 3.088 Q 178.658 3.099 178.722 3.114 A 1.322 1.322 0 0 1 178.8 3.135 L 178.395 4.53 A 1.464 1.464 0 0 0 178.073 4.438 Q 177.924 4.413 177.755 4.41 A 2.487 2.487 0 0 0 177.72 4.41 A 1.944 1.944 0 0 0 176.726 4.687 A 2.342 2.342 0 0 0 176.662 4.725 Q 176.163 5.038 175.842 5.691 A 3.416 3.416 0 0 0 175.837 5.7 Q 175.515 6.36 175.515 7.38 L 175.515 11.025 Z M 65.28 11.205 Q 64.17 11.205 63.285 10.688 Q 62.4 10.17 61.897 9.248 A 4.118 4.118 0 0 1 61.435 7.778 A 5.223 5.223 0 0 1 61.395 7.125 A 5.251 5.251 0 0 1 61.493 6.089 A 3.903 3.903 0 0 1 61.905 4.95 Q 62.415 4.035 63.3 3.54 A 3.925 3.925 0 0 1 65.043 3.051 A 4.699 4.699 0 0 1 65.28 3.045 A 4.161 4.161 0 0 1 66.556 3.236 A 3.727 3.727 0 0 1 67.253 3.54 Q 68.13 4.035 68.648 4.943 A 3.869 3.869 0 0 1 69.092 6.209 A 5.181 5.181 0 0 1 69.165 7.095 Q 69.165 8.34 68.655 9.263 Q 68.145 10.185 67.268 10.695 Q 66.39 11.205 65.28 11.205 Z M 105.33 11.205 Q 104.22 11.205 103.335 10.688 Q 102.45 10.17 101.947 9.248 A 4.118 4.118 0 0 1 101.485 7.778 A 5.223 5.223 0 0 1 101.445 7.125 A 5.251 5.251 0 0 1 101.543 6.089 A 3.903 3.903 0 0 1 101.955 4.95 Q 102.465 4.035 103.35 3.54 A 3.925 3.925 0 0 1 105.093 3.051 A 4.699 4.699 0 0 1 105.33 3.045 A 4.161 4.161 0 0 1 106.606 3.236 A 3.727 3.727 0 0 1 107.303 3.54 Q 108.18 4.035 108.697 4.943 A 3.869 3.869 0 0 1 109.142 6.209 A 5.181 5.181 0 0 1 109.215 7.095 Q 109.215 8.34 108.705 9.263 Q 108.195 10.185 107.317 10.695 Q 106.44 11.205 105.33 11.205 Z M 18.12 11.025 L 16.77 11.025 L 16.77 3.225 L 18.12 3.225 L 18.12 11.025 Z M 171.765 11.025 L 170.415 11.025 L 170.415 3.225 L 171.765 3.225 L 171.765 11.025 Z M 193.71 11.025 L 192.36 11.025 L 192.36 3.225 L 193.71 3.225 L 193.71 11.025 Z M 204.54 11.025 L 203.19 11.025 L 203.19 3.225 L 204.54 3.225 L 204.54 11.025 Z M 65.28 10.005 Q 66.465 10.005 67.125 9.203 A 2.82 2.82 0 0 0 67.698 7.989 A 4.066 4.066 0 0 0 67.785 7.125 A 3.206 3.206 0 0 0 67.601 6.032 A 3.002 3.002 0 0 0 67.455 5.693 A 2.88 2.88 0 0 0 66.829 4.857 A 2.726 2.726 0 0 0 66.563 4.643 Q 66 4.245 65.28 4.245 A 2.887 2.887 0 0 0 64.496 4.346 A 2.106 2.106 0 0 0 63.435 5.025 A 2.682 2.682 0 0 0 62.884 6.131 Q 62.775 6.571 62.775 7.095 Q 62.775 7.875 63.105 8.543 A 2.916 2.916 0 0 0 63.634 9.299 A 2.644 2.644 0 0 0 63.998 9.608 Q 64.56 10.005 65.28 10.005 Z M 105.33 10.005 Q 106.515 10.005 107.175 9.203 A 2.82 2.82 0 0 0 107.748 7.989 A 4.066 4.066 0 0 0 107.835 7.125 A 3.206 3.206 0 0 0 107.651 6.032 A 3.002 3.002 0 0 0 107.505 5.693 A 2.88 2.88 0 0 0 106.879 4.857 A 2.726 2.726 0 0 0 106.613 4.643 Q 106.05 4.245 105.33 4.245 A 2.887 2.887 0 0 0 104.546 4.346 A 2.106 2.106 0 0 0 103.485 5.025 A 2.682 2.682 0 0 0 102.934 6.131 Q 102.825 6.571 102.825 7.095 Q 102.825 7.875 103.155 8.543 A 2.916 2.916 0 0 0 103.684 9.299 A 2.644 2.644 0 0 0 104.048 9.608 Q 104.61 10.005 105.33 10.005 Z M 12.735 9.03 L 12.735 4.845 Q 12.33 4.56 11.843 4.388 Q 11.355 4.215 10.815 4.215 A 2.389 2.389 0 0 0 10.069 4.328 A 2.104 2.104 0 0 0 9.548 4.583 Q 9 4.95 8.685 5.603 A 3.099 3.099 0 0 0 8.422 6.454 A 4.152 4.152 0 0 0 8.37 7.125 A 3.835 3.835 0 0 0 8.449 7.918 A 3.051 3.051 0 0 0 8.685 8.618 A 2.64 2.64 0 0 0 9.151 9.3 A 2.354 2.354 0 0 0 9.555 9.638 Q 10.11 10.005 10.8 10.005 Q 11.37 10.005 11.88 9.728 Q 12.39 9.45 12.735 9.03 Z M 166.38 9.03 L 166.38 4.845 Q 165.975 4.56 165.487 4.388 Q 165 4.215 164.46 4.215 A 2.389 2.389 0 0 0 163.714 4.328 A 2.104 2.104 0 0 0 163.193 4.583 Q 162.645 4.95 162.33 5.603 A 3.099 3.099 0 0 0 162.067 6.454 A 4.152 4.152 0 0 0 162.015 7.125 A 3.835 3.835 0 0 0 162.094 7.918 A 3.051 3.051 0 0 0 162.33 8.618 A 2.64 2.64 0 0 0 162.796 9.3 A 2.354 2.354 0 0 0 163.2 9.638 Q 163.755 10.005 164.445 10.005 Q 165.015 10.005 165.525 9.728 Q 166.035 9.45 166.38 9.03 Z M 35.4 6.585 L 39.675 6.585 A 3.653 3.653 0 0 0 39.614 5.897 Q 39.54 5.51 39.374 5.206 A 1.863 1.863 0 0 0 39.105 4.83 A 1.873 1.873 0 0 0 38.061 4.264 A 2.759 2.759 0 0 0 37.53 4.215 A 2.037 2.037 0 0 0 36.763 4.355 A 1.879 1.879 0 0 0 36.09 4.823 Q 35.616 5.328 35.453 6.213 A 4.803 4.803 0 0 0 35.4 6.585 Z M 83.295 6.585 L 87.57 6.585 A 3.653 3.653 0 0 0 87.509 5.897 Q 87.435 5.51 87.269 5.206 A 1.863 1.863 0 0 0 87 4.83 A 1.873 1.873 0 0 0 85.956 4.264 A 2.759 2.759 0 0 0 85.425 4.215 A 2.037 2.037 0 0 0 84.658 4.355 A 1.879 1.879 0 0 0 83.985 4.823 Q 83.511 5.328 83.348 6.213 A 4.803 4.803 0 0 0 83.295 6.585 Z M 139.305 6.585 L 143.58 6.585 A 3.653 3.653 0 0 0 143.519 5.897 Q 143.445 5.51 143.279 5.206 A 1.863 1.863 0 0 0 143.01 4.83 A 1.873 1.873 0 0 0 141.966 4.264 A 2.759 2.759 0 0 0 141.435 4.215 A 2.037 2.037 0 0 0 140.668 4.355 A 1.879 1.879 0 0 0 139.995 4.823 Q 139.521 5.328 139.358 6.213 A 4.803 4.803 0 0 0 139.305 6.585 Z M 180.54 6.585 L 184.815 6.585 A 3.653 3.653 0 0 0 184.754 5.897 Q 184.68 5.51 184.514 5.206 A 1.863 1.863 0 0 0 184.245 4.83 A 1.873 1.873 0 0 0 183.201 4.264 A 2.759 2.759 0 0 0 182.67 4.215 A 2.037 2.037 0 0 0 181.903 4.355 A 1.879 1.879 0 0 0 181.23 4.823 Q 180.756 5.328 180.593 6.213 A 4.803 4.803 0 0 0 180.54 6.585 Z M 16.791 1.618 A 0.896 0.896 0 0 0 17.445 1.89 A 1.226 1.226 0 0 0 17.669 1.87 A 0.847 0.847 0 0 0 18.135 1.628 A 0.867 0.867 0 0 0 18.349 1.258 A 1.127 1.127 0 0 0 18.39 0.945 A 1.091 1.091 0 0 0 18.39 0.933 A 0.909 0.909 0 0 0 18.112 0.278 A 1.109 1.109 0 0 0 18.104 0.269 A 0.909 0.909 0 0 0 17.445 0 A 1.24 1.24 0 0 0 17.197 0.024 A 0.849 0.849 0 0 0 16.755 0.255 A 0.838 0.838 0 0 0 16.534 0.65 A 1.198 1.198 0 0 0 16.5 0.945 A 0.899 0.899 0 0 0 16.574 1.308 A 0.996 0.996 0 0 0 16.777 1.605 A 1.12 1.12 0 0 0 16.791 1.618 Z M 170.436 1.618 A 0.896 0.896 0 0 0 171.09 1.89 A 1.226 1.226 0 0 0 171.314 1.87 A 0.847 0.847 0 0 0 171.78 1.628 A 0.867 0.867 0 0 0 171.994 1.258 A 1.127 1.127 0 0 0 172.035 0.945 A 1.091 1.091 0 0 0 172.035 0.933 A 0.909 0.909 0 0 0 171.757 0.278 A 1.109 1.109 0 0 0 171.749 0.269 A 0.909 0.909 0 0 0 171.09 0 A 1.24 1.24 0 0 0 170.842 0.024 A 0.849 0.849 0 0 0 170.4 0.255 A 0.838 0.838 0 0 0 170.179 0.65 A 1.198 1.198 0 0 0 170.145 0.945 A 0.899 0.899 0 0 0 170.219 1.308 A 0.996 0.996 0 0 0 170.422 1.605 A 1.12 1.12 0 0 0 170.436 1.618 Z M 192.381 1.618 A 0.896 0.896 0 0 0 193.035 1.89 A 1.226 1.226 0 0 0 193.259 1.87 A 0.847 0.847 0 0 0 193.725 1.628 A 0.867 0.867 0 0 0 193.939 1.258 A 1.127 1.127 0 0 0 193.98 0.945 A 1.091 1.091 0 0 0 193.98 0.933 A 0.909 0.909 0 0 0 193.702 0.278 A 1.109 1.109 0 0 0 193.694 0.269 A 0.909 0.909 0 0 0 193.035 0 A 1.24 1.24 0 0 0 192.787 0.024 A 0.849 0.849 0 0 0 192.345 0.255 A 0.838 0.838 0 0 0 192.124 0.65 A 1.198 1.198 0 0 0 192.09 0.945 A 0.899 0.899 0 0 0 192.164 1.308 A 0.996 0.996 0 0 0 192.367 1.605 A 1.12 1.12 0 0 0 192.381 1.618 Z M 203.211 1.618 A 0.896 0.896 0 0 0 203.865 1.89 A 1.226 1.226 0 0 0 204.089 1.87 A 0.847 0.847 0 0 0 204.555 1.628 A 0.867 0.867 0 0 0 204.769 1.258 A 1.127 1.127 0 0 0 204.81 0.945 A 1.091 1.091 0 0 0 204.81 0.933 A 0.909 0.909 0 0 0 204.532 0.278 A 1.109 1.109 0 0 0 204.524 0.269 A 0.909 0.909 0 0 0 203.865 0 A 1.24 1.24 0 0 0 203.617 0.024 A 0.849 0.849 0 0 0 203.175 0.255 A 0.838 0.838 0 0 0 202.954 0.65 A 1.198 1.198 0 0 0 202.92 0.945 A 0.899 0.899 0 0 0 202.994 1.308 A 0.996 0.996 0 0 0 203.197 1.605 A 1.12 1.12 0 0 0 203.211 1.618 Z" vector-effect="non-scaling-stroke"/>
                      </svg>
                    </svg>
                  </Col>
                </Col>
              )}
              {data.feedback?.enable === true && (
                <Col className="feedback-container">
                  {data.feedback.stars === true && (
                    <Col md="4" className="d-flex">
                      {getFeedBackIcons()}
                    </Col>
                  )}
                  {data.feedback.comments === true && (
                    <Col className="d-flex flex-column pt-5">
                      <div>
                        <textarea
                          onChange={(event) => setComment(event.target.value)}
                          style={{ width: "100vh", height: "84px" }}
                          placeholder="Laissez votre commentaire ici"
                        ></textarea>
                      </div>
                    </Col>
                  )}
                  <Col className="d-flex flex-column align-items-center pt-5 ">
                    <div>
                      <Button
                        className="btn-round-sm mt-3"
                        color="primary"
                        type="submit"
                        onClick={sendFeedback}
                      >
                        Envoyer les feedbacks
                      </Button>
                    </div>
                  </Col>
                </Col>
              )}
            </Col>
          </Row>
        </Col>
      )}
    </Fragment>
  );
};

export default TrainingSynchrone;
